import { LOCAL_NAVIGATION_API } from '@/constants'

function forceHTTP(url: string) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`
  }

  return url
}

function getNavigationApiUrl(): string {
  return forceHTTP(LOCAL_NAVIGATION_API)
}

export { getNavigationApiUrl }
